const TOP_LEFT = 'top-left'
export const ALIGNMENT_NAMES = { TOP_LEFT }
